import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const loginService = createApi({
  reducerPath: "loginService",
  tagTypes: ["login"],
  baseQuery: fetchBaseQuery({ baseUrl: "https://api.upswap.app/api" }),
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/register/v2/",
        method: "POST",
        body: newPost,
      }),
    }),
    loginUser: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/login/",
        method: "POST",
        body: newPost,
      }),
    }),
    forgotPasswordEmailSend: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/send/email/forgot-password/",
        method: "POST",
        body: newPost,
      }),
    }),
    forgotPasswordOTPVerify: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/verify/otp/forgot-password/",
        method: "POST",
        body: newPost,
      }),
    }),
    forgotPasswordResetPassword: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/reset-password/v2/",
        method: "POST",
        body: newPost,
      }),
    }),
    //*****************//PUBLIC USER API//*****************//
  
    resendOTP: builder.mutation({
      invalidatesTags: ["login"],
      query: () => ({
        url: "/resend-otp/",
        method: "POST",
      }),
    }),
    verifyOTP: builder.mutation({
      query: (body) => ({
        url: "verify/create/v2/",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      }),
    }),
    resendRegister: builder.mutation({
      query: (body) => ({
        url: "/resend/register/otp/",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: body,
      }),
    }),
    registerNewFlow: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/register/v3/",
        method: "POST",
        body: newPost,
      }),
    }),
    registerNewFlowOtpVerify: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/verify/register/otp/v3/",
        method: "POST",
        body: newPost,
      }),
    }),
    registerNewFlowCreateAccount: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/create-user/",
        method: "POST",
        body: newPost,
      }),
    }),
    newlogin: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/login/v2/",
        method: "POST",
        body: newPost,
      }),
    }),
    phoneLoginOtpVerify: builder.mutation({
      invalidatesTags: ["login"],
      query: (newPost) => ({
        url: "/login-otp/",
        method: "POST",
        body: newPost,
      }),
    }),
    createAccountResendOTP: builder.mutation({
      invalidatesTags: ["login"],
      query: (body) => ({
        url: "/resend/register/otp/",
        method: "POST",
        body: body,
      }),
    }),
    phoneLoginResendOTP: builder.mutation({
      invalidatesTags: ["login"],
      query: (body) => ({
        url: "/resend/login/otp/",
        method: "POST",
        body: body,
      }),
    }),
    socialLogin: builder.mutation({
      invalidatesTags: ["login"],
      query: (body) => ({
        url: "/social-login/",
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useForgotPasswordEmailSendMutation,
  useForgotPasswordOTPVerifyMutation,
  useForgotPasswordResetPasswordMutation,
 
  useResendOTPMutation,
  useRegisterUserMutation,
  useVerifyOTPMutation,
  useResendRegisterMutation,
  useRegisterNewFlowMutation,
  useRegisterNewFlowOtpVerifyMutation,
  useRegisterNewFlowCreateAccountMutation,
  useNewloginMutation,
  usePhoneLoginOtpVerifyMutation,
  useCreateAccountResendOTPMutation,
  usePhoneLoginResendOTPMutation,
  useSocialLoginMutation,
} = loginService;
export default loginService;
